import User from "./User_b";
import Profile from "./Profile_b";
import Settings from "./Settings_b";
import Relationship from "./Relationship_b";
import Address from "./Address_b";
import Group from "./Group";
import Post from "./Post";
import Poll from "./Poll";

const MODELS = {
    User,
    Profile,
    Settings,
    Relationship,
    Address,
    Group,
    Post,
    Poll
}

export default MODELS;
